import { Ban, LogOut } from "lucide-react";
import { Logo } from "@/components/landing/Logo";
import { useAuth } from "@/context/AuthContext";

/* Shown by ProtectedRoute whenever the signed-in user has `is_blocked`. We
   deliberately render on top of the normal auth flow instead of signing
   the user out, so they can clearly see WHY they can't continue. The only
   available action is "Log out" — all product routes stay inaccessible. */

export default function BlockedScreen() {
  const { user, logout } = useAuth();
  return (
    <main
      data-testid="blocked-screen"
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#0A0A0A] px-6 font-body text-white"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(229,37,37,0.12),transparent_60%)] blur-3xl"
      />
      <div className="relative mb-10">
        <Logo className="text-2xl" />
      </div>
      <div className="relative mx-auto max-w-md rounded-2xl border border-[#E52525]/30 bg-[#141414] p-8 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#E52525]/15 text-[#E52525]">
          <Ban size={28} />
        </div>
        <h1 className="font-heading mt-5 text-2xl font-black tracking-tight">
          Your SalesPit account is suspended
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-zinc-400">
          You can't use SalesPit right now. If you believe this is a mistake,
          email us at{" "}
          <a
            href="mailto:hello@salespit.io"
            className="text-white underline decoration-[#E52525]/60 decoration-2 underline-offset-4"
          >
            hello@salespit.io
          </a>
          .
        </p>
        {user?.blocked_reason && (
          <p
            data-testid="blocked-reason"
            className="mt-4 rounded-xl bg-black/40 px-4 py-3 text-xs italic text-zinc-300"
          >
            "{user.blocked_reason}"
          </p>
        )}
        <button
          type="button"
          data-testid="blocked-logout-btn"
          onClick={logout}
          className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-5 py-2.5 text-sm font-semibold text-zinc-200 hover:bg-white/[0.07]"
        >
          <LogOut size={14} />
          Log out
        </button>
      </div>
    </main>
  );
}
